module.exports = __webpack_public_path__ + "img/testimonial-01.78323800.jpg";